import React, { Component } from 'react';
import { ReactInternetSpeedMeter } from 'react-internet-meter'

class test2 extends Component {

    render() {
        return (
            <div>
                <br /> <br /> <br /> <br /> <br />
                <div >
                    <ReactInternetSpeedMeter
                        txtSubHeading="Internet is too slow"
                        pingInterval={4000} // milliseconds 
                        thresholdUnit='megabyte' // "byte" , "kilobyte", "megabyte" 
                        threshold={100}
                        downloadSize="1781287"  //bytes 
                        callbackFunctionOnNetworkDown={(speed) => document.write(`${speed} Mbps `)}
                    />
                </div>
            </div>
        );
    }
}

export default test2;